import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from '@frontend-site/main-header/domain';
import { Observable } from 'rxjs';
import { RouterState, RouterStoreService } from '@frontend-site/shared/router-store';
import { ColorName } from '@panaya/ui/styles-to-code';

@Component({
    selector: 'p-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsComponent {
    @Input() data: MenuItem[] = [];
    @Input() iconColor: ColorName = 'base-light';
    @Input() previousPath = '';
    @Output() closeEvent = new EventEmitter();
    slideOut = false;
    routeState$: Observable<RouterState>;

    constructor(private readonly router: Router, routerStoreService: RouterStoreService) {
        this.routeState$ = routerStoreService.state$;
    }

    navigate(routePath: string): void {
        this.router.navigateByUrl(routePath);
    }

    close(): void {
        this.slideOut = true;
        setTimeout(() => {
            this.navigate(this.previousPath);
            this.closeEvent.emit(true);
        }, 500);
    }
}
